import React, { useState } from "react";
import { FiPlus, FiMinus } from "react-icons/fi"; // Import icons from react-icons

export const EnrolledStd = () => {
	const [openIndex, setOpenIndex] = useState(null);

	const norms = [
		
		{
			name: "Mechanical First Year Student List: 2021 to 2024",
			url: "https://gpsakoli.ac.in/public/api/assets/StudentList_PDFs/mechanical/ME12021-24.pdf",
		},
		{
			name: "Mechanical Second Year Student List: 2020 to 2024",
			url: "https://gpsakoli.ac.in/public/api/assets/StudentList_PDFs/mechanical/ME3I.pdf",
		},
		{
			name: "Mechanical Third Year Student List: 2020 to 2024",
			url: "https://gpsakoli.ac.in/public/api/assets/StudentList_PDFs/mechanical/ME5I2020-24.pdf",
		},
		{
			name: "Electronics and Telecommunication Engineering Student List: 2021 to 2024",
			url: "https://gpsakoli.ac.in/public/api/assets/StudentList_PDFs/electronics/EJ_Roll_Call_List.pdf",
		},
		{
			name: "Electrical Engineering Student List: 2022 to 2025",
			url: "https://gpsakoli.ac.in/public/api/assets/StudentList_PDFs/electrical/RollListEE_W22_S25.pdf",
		},

	];

	const togglePDF = (index) => {
		setOpenIndex(openIndex === index ? null : index);
	};

	return (
		<div className="container mx-auto p-4">
			<h1 className="heading heading-top-left-line">Enrolled Student List Branch/Year Wise
</h1>
			<ul className="space-y-3">
				{norms.map((norm, index) => (
					<li
						key={index}
						className="p-4 shadow-md "
						style={{
							background: "linear-gradient(160deg, var(--primary-bg-red), var(--card-linear-dark-red))",
						}}
					>
						<button
							onClick={() => togglePDF(index)}
							className="w-full flex justify-between items-center text-lg font-semibold text-white hover:underline focus:outline-none"
						>
							<span> {norm.name}</span>
							{openIndex === index ? <FiMinus size={20} /> : <FiPlus size={20} />}
						</button>

						{openIndex === index && (
							<div className="mt-3 border rounded-lg overflow-hidden">
								<iframe
									src={norm.url}
									width="100%"
									height="500px"
									className="border-none"
									title={norm.name}
								></iframe>
							</div>
						)}
					</li>
				))}
			</ul>
		</div>
	);
};
